var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slides.length !== 0)?[(_vm.design === 'classic')?_c('welcome-screen-classic',{attrs:{"slides":_vm.slides}}):_vm._e(),(_vm.design === 'light')?_c('welcome-screen-light',{attrs:{"slides":_vm.slides}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }